import { Checkbox, Form, Typography } from "antd";
import { LabeledField } from "../../../../../common/components/labeledField/labeledField";

export default function UDFCheckbox({
  title = "",
  isFormItem = true,
  formItemName = "",
  required = true,
  options = [],
  style = {},
  disabled = false,
  extraLabel = null,
}) {
  const checkboxOptions = options.map((opt) => ({
    label: opt.value,
    value: opt.id,
  }));

  const renderField = () => (
    <Checkbox.Group
      options={checkboxOptions}
      style={style}
      disabled={disabled}
    />
  );

  if (isFormItem) {
    return (
      <Form.Item
        label={title}
        name={formItemName}
        rules={
          required ? [{ required: true, message: `Select ${title}` }] : null
        }
      >
        {renderField()}
      </Form.Item>
    );
  }

  return (
    <LabeledField label={title} required={required} extra={extraLabel}>
      {renderField()}
    </LabeledField>
  );
}
